export default "__VITE_ASSET__01774282__"